module.exports = __webpack_public_path__ + "static/media/defaultProfile.1b33e7e9.svg";